import {
  ShipmentReportFilters,
  LegReportFilters,
  JobReportFilters,
  JobSummaryReportFilters,
  LmsAircraftLoadReportFilters,
  LmsLoadByDateReportFilters,
  LmsLoadByTypeReportFilters,
  LmsReceiveByTypeReportFilters,
  LmsOnHandReportFilters,
  AccountReportFilters,
  TrackingReportFilters,
  QuoteHistoryReportFilters,
  QuoteHistoryByLegReportFilters,
} from '../';

type Props = {
  isAdmin: boolean;
  reportType: string;
};

export default function ReportFilters({ isAdmin, reportType }: Props) {
  switch (reportType) {
    case 'ACCOUNT': {
      return <AccountReportFilters isAdmin={isAdmin} />;
    }
    case 'SHIPMENT_OVERVIEW': {
      return <ShipmentReportFilters isAdmin={isAdmin} />;
    }
    case 'LEG_OVERVIEW': {
      return <LegReportFilters isAdmin={isAdmin} />;
    }
    case 'LEG_TRACKING': {
      return <TrackingReportFilters isAdmin={isAdmin} />;
    }
    case 'JOB_OVERVIEW': {
      return <JobReportFilters isAdmin={isAdmin} />;
    }
    case 'JOB_SUMMARY': {
      return <JobSummaryReportFilters isAdmin={isAdmin} />;
    }
    case 'LMS_LOAD_SUMMARY': {
      return <LmsAircraftLoadReportFilters isAdmin={isAdmin} />;
    }
    case 'LMS_LOAD_BY_DATE': {
      return <LmsLoadByDateReportFilters isAdmin={isAdmin} />;
    }
    case 'LMS_LOAD_BY_TYPE': {
      return <LmsLoadByTypeReportFilters isAdmin={isAdmin} />;
    }
    case 'LMS_RECEIVED_SUMMARY': {
      return <LmsReceiveByTypeReportFilters isAdmin={isAdmin} />;
    }
    case 'LMS_ON_HANDS': {
      return <LmsOnHandReportFilters isAdmin={isAdmin} />;
    }
    case 'QUOTE_HISTORY': {
      return <QuoteHistoryReportFilters isAdmin={isAdmin} />;
    }
    case 'QUOTE_HISTORY_LEG': {
      return <QuoteHistoryByLegReportFilters isAdmin={isAdmin} />;
    }
    default: {
      return <div></div>;
    }
  }
}
